import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        pictureFeature: {
          module: () => import('./picture.module').then((m) => m.PictureModule),
        },
      }
    }),
  ]
})
export class PictureFeatureModule {}
